<section [class.required]="required()" [class.invalid]="!isValid" [class.read-only]="isReadOnly">
  @if (value.length > 0) {
    <span class="label">{{ tag() | documentTagLabel }}</span>
    <ul class="selected-files">
      @for (file of value; track $index) {
        <li class="selected-file">
          @if (file.uploadState === 'waiting') {
            <button mat-icon-button disabled matTooltip="Chargement...">
              <mat-icon class="spinning">autorenew</mat-icon>
            </button>
          } @else if (file.uploadState === 'error') {
            <button
              mat-icon-button
              (click)="filterOut(file)"
              matTooltip="Retirer le fichier"
              [disabled]="isReadOnly"
            >
              <mat-icon>cancel</mat-icon>
            </button>
          } @else {
            <button
              mat-icon-button
              color="warn"
              (click)="preview(file)"
              matTooltip="Prévisualiser le fichier"
            >
              <mat-icon>visibility</mat-icon>
            </button>
            <button
              mat-icon-button
              color="warn"
              (click)="removeFile(file)"
              matTooltip="Supprimer le fichier"
            >
              <mat-icon>delete_outline</mat-icon>
            </button>
          }

          <span>{{ file.name }}</span>

          @if (file.uploadState === 'error') {
            <mat-icon class="help" matTooltip="{{ file.uploadError || 'Erreur lors de l\'envoi' }}"
              >error_outline</mat-icon
            >
          }
        </li>
      }
    </ul>
  } @else {
    <div>
      <span class="label">{{ tag() | documentTagLabel }}</span>
      @if (isReadOnly) {
        <span class="no-file">N/A</span>
      }
    </div>
  }

  @if (!isReadOnly) {
    <app-drop-input-file
      [allowedTypes]="acceptedImageMimeTypes"
      [multiple]="true"
      (choosenFiles)="onChoosenFile($event)"
    ></app-drop-input-file>
  }
</section>
